module.exports = __webpack_public_path__ + "static/media/ppcc.6f99e2aa.svg";